import { useEffect, useRef, useState } from "react";
import { categoryAPI } from "../../api/categoryAPI";

export default function CategoryTypeSearch({ setCatCode, setCatName, pCode, setIsAllCategoriesChecked }) {
    const [allCategories, setAllCategories] = useState([]);

    const isFirstRender = useRef(false);

    const getCategories = (searchKey = '') => {
        categoryAPI.getCategories(pCode, searchKey).then((data) => {
            setAllCategories(data);
        })
    }

    const handleRowSelect = (code, name) => {
        setCatCode(code);
        setCatName(name);
        setIsAllCategoriesChecked(false);
    }

    useEffect(() => {
        if (!isFirstRender.current) {
            isFirstRender.current = true;
            getCategories();
        }
    }, [])

    return (
        <div className="modal fade" id="categoryTypeSearch" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Category</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div className="modal-body">
                        <input type="text" className="form-control" placeholder="Search by code or name"
                            onChange={(e) => getCategories(e.target.value)} />
                        <table className="table mt-1">
                            <thead className="thead--color">
                                <tr>
                                    <th scope="col">Code</th>
                                    <th scope="col">Name</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {allCategories && allCategories.map(data => (
                                    <tr key={data.catCode}>
                                        <td>{data.catCode}</td>
                                        <td>{data.catName}</td>
                                        <td className="text-center"><button type="button" className="btn btn-sm btn-dark"
                                            onClick={() => handleRowSelect(data.catCode, data.catName)} data-bs-dismiss="modal">
                                            Select</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}